import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { cn } from "@/lib/utils";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className, delay = 0, gap = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8% 0px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className, y = 32 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className, lineClassName, delay = 0, as: Tag = "h1", inView = false, stagger = 0.13 }) => {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, margin: "-10% 0px" });
  const go = inView ? visible : true;
  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={cn("block will-change-transform", typeof lineClassName === "function" ? lineClassName(i) : lineClassName)}
            initial={{ y: "115%" }}
            animate={{ y: go ? 0 : "115%" }}
            transition={{ duration: 1.1, delay: go ? delay + i * stagger : 0, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const LineDraw = ({ className, delay = 0 }) => (
  <motion.span
    className={cn("block h-px bg-crimson origin-left", className)}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay, ease: EASE }}
  />
);
